import { observable, action } from 'mobx';

export enum SidebarType {
  Closed,
  Leads,
  Activities,
  Profile,
}

export class Sidebar {
  // Properties
  @observable public open: SidebarType = SidebarType.Closed;
  @observable public width: number = 420;

  // Open sidebar
  @action public openSidebar = async (
    type: SidebarType,
    newWidth?: number
  ): Promise<boolean> => {
    if (newWidth) {
      this.width = newWidth;
    }

    const closed: boolean = await this.closeSidebar();

    this.open = type;

    await setTimeout(() => {
      return true;
    }, 600);

    return false;
  };

  // Close sidebar
  @action public closeSidebar = async (): Promise<boolean> => {
    this.open = SidebarType.Closed;

    if (this.open !== SidebarType.Closed) {
      await setTimeout(() => {
        return true;
      }, 600);

      return false;
    } else {
      return true;
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Sidebar.ts